import { Mail, PhoneIcon } from 'lucide-react';
import React, { useState, useEffect, useRef } from 'react';
import { FaFacebook, FaInstagram, FaTelegram, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import { FaTiktok } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

export default function Footer() {
  
  const [contactData, setContactData] = useState(true);

  const fetchContactData = async () => {
    
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/contactdata/1`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setContactData(json.data || []);
  
      } catch (err) {
          console.error("Fetch Running error:", err);
      }
    };
    
    useEffect(() => {
      fetchContactData();
    }, []);  

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex mb-4">
              <Link to="/" className="flex-shrink-0 group cursor-pointer">
                <div className="flex">
                  <div className="flex">
                    <img src="/images/Logo RP.png" alt="Radar Logo" className="h-12 w-auto flex group-hover:animate-softPulse" />
                  </div>
                </div>
              </Link>
            </div>
            <p className="text-gray-400 text-sm">
              Radar Pulsa hadir sebagai Mitra Terpercaya Bisnis Anda, membantu Anda berkembang dengan sistem yang stabil, harga kompetitif, dan dukungan penuh setiap saat.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Pintasan Cepat</h4>
            <ul className="space-y-2">
              {[
                { name: 'Beranda', path: '/' },
                { name: 'Tentang Kami', path: '/about' },
                { name: 'Panduan', path: '/services' },
                { name: 'Media Promosi', path: '/media-promosi' },
              ].map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Office</h4>
            <p className='text-sm text-gray-400'>
              <Link to="https://maps.app.goo.gl/hbRTFza8GFnh3S8J8" target="_blank" className="flex-shrink-0 group cursor-pointer">{contactData.address}</Link><br/>
              <Link to={`tel:${contactData.phone}`} target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2 mt-2'>
                  <PhoneIcon size={16}></PhoneIcon> {contactData.phone}
                </div>
              </Link>
              <Link to={`https://wa.me/${contactData.whatsapp1}`} target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2'>
                  <FaWhatsapp size={16}></FaWhatsapp> +{contactData.whatsapp1}
                </div>
              </Link>
              <Link to={`mailto:${contactData.email}`} target="_blank" className="flex-shrink-0 group cursor-pointer">
                <div className='flex flex-row gap-2'>
                  <Mail size={16}></Mail> {contactData.email}
                </div>
              </Link>
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Ikuti Kami:</h4>
            <div className="flex space-x-2">
              <div className="relative group">
                <a 
                  href={`${contactData.facebook}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaFacebook size={18}></FaFacebook></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Facebook Radar Pulsa
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`${contactData.instagram}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaInstagram size={18}></FaInstagram></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Instagram Radar Pulsa
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`${contactData.youtube}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaYoutube size={18}></FaYoutube></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Official Youtube Channel Radar Pulsa
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`${contactData.tiktok}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaTiktok size={18}></FaTiktok></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Tiktok Radar Pulsa
                </div>
              </div>
            </div>
            <div className="flex space-x-2 pt-2">
              <div className="relative group">
                <a
                  href={`${contactData.telegram}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaTelegram size={18}></FaTelegram></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Telegram Radar Pulsa
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`https://wa.me/${contactData.whatsapp1}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 1
                </div>
              </div>
              <div className="relative group">
                <a
                  href={`https://wa.me/${contactData.whatsapp2}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 2
                </div>
              </div><div className="relative group">
                <a
                  href={`https://wa.me/${contactData.whatsapp3}`} target="_blank"
                  className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-600 hover:to-red-600 transition-all duration-300 transform hover:scale-110"
                >
                  <span className="text-sm text-white font-semibold"><FaWhatsapp size={18}></FaWhatsapp></span>
                </a>
                <div className="absolute bottom-full mb-2 hidden group-hover:block w-32 p-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg">
                  Whatsapp 3
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 Putra Jaya Telesindo. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
